export default "__VITE_ASSET__YUTp0xY5__"